import axios from 'axios';
import router from '../router';
import storage from '../utils/storage';
// 登录相关
const loginUrl = [
    `/system/login`,
    `/system/getValidateCode`,
    `/system/sendSms`
];
//创建axios的一个实例
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    timeout: 6000
});

//------------------- 一、请求拦截器 后面介绍
instance.interceptors.request.use(function (config) {
    if(config.url.indexOf('getModuleMenu') == -1 && config.url.indexOf('getValidateCode') == -1 && config.url.indexOf('login') == -1 && config.url.indexOf('sendSms') == -1) {
        config.headers.Authorization = storage.get("user").token
        config.headers.userName =  encodeURI(storage.get("user").userName)
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// http response 拦截器
instance.interceptors.response.use(
    (response) => {
        if (response.data.code == -25) {
            storage.remove('user');
            router.push({
                path: '/login',
                querry: {
                    redirect: router.currentRoute.fullPath
                }, // 从哪个页面跳转
            });
        }
        return response;
    },
    error => Promise.reject(error),
);

//----------------- 二、响应拦截器 后面介绍
instance.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

/**
 * 使用es6的export default导出了一个函数，导出的函数代替axios去帮我们请求数据，
 * 函数的参数及返回值如下：
 * @param {String} method  请求的方法：get、post、delete、put
 * @param {String} url     请求的url:
 * @param {Object} data    请求的参数
 * @returns {Promise<AxiosResponse<T>>}     返回一个promise对象，其实就相当于axios请求数据的返回值
 */
const request = function (origMethod, url, data = null, config = {}) {
    const method = origMethod.toLowerCase();
	let dataParmars;
    let header = {
        headers: {
            // 'Authorization': storage.get("user").token,
            // 'userName': URLEncoder.encode(storage.get("user").userName, 'UTF-8')
        }
    }
	// 登录相关去除用户信息
	if (loginUrl.includes(url)) {
		dataParmars = { ...data }
	} else {
		dataParmars = {
			// token: storage.get("user").token,
			// userName: storage.get("user").userName,
			...data
		}
	}
    if (method === 'post') {
        // const { op, token, ...rest } = config;
        // if(op !== null && token !== null) {
        //
        // }
        return instance.post(url, dataParmars, config);
    }
    if (method === 'get') {
        return instance.get(url,{
            params: dataParmars
        }, config);
    }
    if (method === 'delete') {
        return instance.delete(url, {
            params: dataParmars
        }, config);
    }
    if (method === 'put') {
        return instance.put(url, dataParmars, config);
    }
    console.error(`未知的method${method}`);
    return false;
};

export default request;
